import styled from 'styled-components';
import { WHITE, ORANGE, BLUE, LIGHT_BLUE } from 'root/theme';
import InlineBellSVG from 'svg-inline-react';

const BellIcon = styled(InlineBellSVG)`
  svg {
    width: 40px;
    height: 43px;
    g path {
      fill: ${(props) => props.displaycount ? BLUE : LIGHT_BLUE};
      stroke: ${(props) => props.displaycount ? BLUE : LIGHT_BLUE};
    }
  }
`;

const NotificationIconContainer = styled.span`
  padding: 1rem 0;
  top: .25rem;
  position: relative;
  cursor: pointer;
  &:hover {
    ${BellIcon} {
      transform: translateY(2px);
    }
  }
`;

const CountBox = styled.div`
  background-color: ${ORANGE};
  min-width: 26px;
  font-size: 0.75rem;
  padding: 0.1rem 0.25rem;
  color: ${WHITE};
  text-decoration: none;
  border-radius: 50px;
  border: white 2px solid;
  text-align: center;
  line-height: 20px;
  position: absolute;
  top: -.25rem;
  right: 0rem;
  pointer-events: none;
`;

export {
  CountBox,
  NotificationIconContainer,
  BellIcon,
};
